import React from "react";
import { Autocomplete } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
const BehaviorCategoryFilter = ({ category, categoryOptions, onChange, className, loading, onOpen, }) => {
    return (React.createElement(Autocomplete, { id: "filter-behavior-category", label: "Filter by category", className: className, isClearAlwaysVisible: category !== "ALL", value: category, onOpen: onOpen, onChange: (_event, value) => onChange(value !== null && value !== void 0 ? value : "ALL"), options: ["ALL", ...categoryOptions], loading: loading, getOptionLabel: (option) => {
            return option === "ALL"
                ? "Show all categories"
                : capitalizeFirstLetter(option);
        } }));
};
export default BehaviorCategoryFilter;
//# sourceMappingURL=BehaviorCategoryFilter.js.map